// src/components/BarChart.js

import { Badge } from '@outbound-ai/ursa'
import styled from 'styled-components'
interface BarProps {
  width: number
}

interface BarChartProps {
  data: { label: string; value: number }[]
}

const BarChartContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 80%;
  margin-left: auto;
  margin-right: ${({ theme }) => theme.spacing.s}!important;
  justify-content: center;
`

const Bar = styled.div<BarProps>`
  height: 24px;
  background-color: ${({ theme }) => theme.colors.info.neutral};
  position: relative;
  width: ${(props) => props.width}%;
  margin-bottom: 8px;
  border-radius: 2px;
`

const BarLabel = styled.span`
  position: absolute;
  right: 100%;
  top: 50%;
  transform: translateY(-50%);
  white-space: nowrap;
  margin-right: 8px;
`

const BarValue = styled.span`
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  white-space: nowrap;
  margin-left: 10px;
  ${({ theme }) => theme.typography.s.normal};
  color: ${({ theme }) => theme.colors.neutral.neutral};
`

const BarChart: React.FC<BarChartProps> = ({ data }: any) => {
  const maxValue = Math.max(...data.map((item: any) => item.value))

  return (
    <BarChartContainer>
      {data.map((item: any, index: any) => (
        <Bar key={index} width={maxValue === 0 ? 0 : (item.value / maxValue) * 100}>
          <BarLabel>
            {' '}
            <Badge type="info" variant="tag">
              {' '}
              {item.label}
            </Badge>
          </BarLabel>
          <BarValue>{item.value}</BarValue>
        </Bar>
      ))}
    </BarChartContainer>
  )
}

export default BarChart
